/**
 * Generic REST helper wrappers.
 *
 * Thin promise-based wrappers around the pre-configured Axios instance
 * (including auth and 401-refresh interceptors).  All handlers in the
 * `service/` directory use these helpers rather than calling Axios directly
 * so that the interceptor chain is consistently applied.
 */
import axios from "@interceptors/index";

const defaultHeader = {
  "Content-Type": "application/json",
};
/**
 * Send a POST request.
 *
 * @param url     - Relative URL (resolved against the configured base URL).
 * @param body    - Request body string (typically `JSON.stringify(...)`).
 * @param headers - Optional header overrides; defaults to `application/json`.
 */
export const postMethod = (
  url: string,
  body: String,
  headers: any = defaultHeader
) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, body, {
        headers: headers,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
/**
 * Send a GET request.
 *
 * @param url     - Relative URL.
 * @param headers - Optional header overrides.
 */
export const getMethod = (url: string, headers: any = defaultHeader) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
/**
 * Send a PUT request.
 *
 * @param url     - Relative URL.
 * @param body    - Request body string.
 * @param headers - Optional header overrides.
 */
export const putMethod = (
  url: string,
  body: String,
  headers: any = defaultHeader
) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, body, {
        headers: headers,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
/**
 * Send a DELETE request.
 *
 * @param url     - Relative URL.
 * @param headers - Optional header overrides.
 */
export const deleteMethod = (url: string, headers: any = defaultHeader) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        headers: headers,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
